import React from 'react';

const Empty = () => (
    <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center text-gray-500 text-lg font-medium">Not Access to This Page.</div>
    </div>
);

export default Empty;
